<template>
    <div>
        <v-container :loading="loading" style="max-width:1000px">
            <v-form ref="form" :loading="loading">
                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Din mail"
                    required
                ></v-text-field>
                <v-btn style="background-color:#ffa500" @click="submit" class="mr-4">
                    Skicka mail
                    <v-icon style="margin-left:2px;font-size:20px">fas fa-envelope</v-icon>
                </v-btn>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import store from "../../store";
export default {
    name: "passwordreset",
    data: () => ({
        store: store,
        email: "",
        loading: false,
        emailRules: [
            v => !!v || "Din mail krävs",
            v => /.+@.+\..+/.test(v) || "Email måste vara giltig"
        ]
    }),
    methods: {
        submit: async function() {
            this.loading = true;
            if (this.$refs.form.validate()) {
                let bodyFormData = new FormData();
                bodyFormData.set("email", this.email);
                var config = {
                    method: "post",
                    url: "",
                    headers: {
                        "Content-Type": "application/form-data;charset=utf-8",
                        "Access-Control-Allow-Origin": "*",
                        Accept: "*/*"
                    },
                    data: bodyFormData
                };
                await this.store.dispatch("passreset", config);
                this.loading = false;
                this.$router.replace("setpassword");
            }
        }
    }
};
</script>

<style></style>
